'use strict';

function SearchFormClick() {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Buscar'
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Buscar'
  });
}

function SearchFormSelected(context, selected_item) {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Seleção - ' + context,
    'eventLabel': selected_item
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Seleção - ' + context,
    'eventLabel': selected_item
  });
}